import { PragmaticPlayGames } from "./pragmaticplayGames.data";

export const pageUrlGenerator = (page) =>
  `${window.location.protocol}//${window.location.host}${page}`;

export const SlotGames = {
  netenttab: {
    slide1: {
      asgardianstones: {
        redirectUrl: "/casino/ezgne-asgardian-stones",
        code: "1100096",
        casino: "ezugi",
        providerName: "NetEnt",
        homeUrl: pageUrlGenerator("/slots"),
        imgUrl: "./images/slots/asgardianstones.jpg",
        alt: "Asgardian Stones",
        name: "Asgardian Stones",
      },
      secrets: {
        redirectUrl: "/casino/ezgne-secrets-of-atlantis",
        code: "1100106",
        casino: "ezugi",
        providerName: "NetEnt",
        homeUrl: pageUrlGenerator("/slots"),
        imgUrl: "./images/slots/secrets-of-atlantis.jpg",
        alt: "Secrets of Atlantis",
        name: "Secrets of Atlantis",
      },
      SteamTower: {
        redirectUrl: "/casino/ezgne-steam-tower",
        code: "1100043",
        casino: "ezugi",
        providerName: "NetEnt",
        homeUrl: pageUrlGenerator("/slots"),
        imgUrl: "./images/slots/Steam-Tower.jpg",
        alt: "Steam Tower",
        name: "Steam Tower",
      },
      DivinieFortuneMegaways: {
        redirectUrl: "/casino/ezgne-divine-fortune-megaways",
        code: "1100089",
        casino: "ezugi",
        providerName: "NetEnt",
        homeUrl: pageUrlGenerator("/slots"),
        imgUrl: "./images/slots/divine_fortune_megaways.jpg",
        alt: "Divine Fortune Megaways",
        name: "Divine Fortune Megaways",
      },
      FruitShopMegaways: {
        redirectUrl: "/casino/ezgne-fruit-shop-megaways",
        code: "1100094",
        casino: "ezugi",
        providerName: "NetEnt",
        homeUrl: pageUrlGenerator("/slots"),
        imgUrl: "./images/slots/Fruit_Shop_Megaways.jpg",
        alt: "Fruit Shop Megaways",
        name: "Fruit Shop Megaways",
      },
      GorillaKingdom: {
        redirectUrl: "/casino/ezgne-gorilla-kingdom",
        code: "1100088",
        casino: "ezugi",
        providerName: "NetEnt",
        homeUrl: pageUrlGenerator("/slots"),
        imgUrl: "./images/slots/Gorilla_Kingdom.jpg",
        alt: "Gorilla Kingdom",
        name: "Gorilla Kingdom",
      },
      Christmas: {
        redirectUrl: "/casino/ezgne-aloha-christmas",
        code: "1100032",
        casino: "ezugi",
        providerName: "NetEnt",
        homeUrl: pageUrlGenerator("/slots"),
        imgUrl: "./images/slots/Aloha-Christmas.jpg",
        alt: "Aloha! Christmas",
        name: "Aloha! Christmas",
      },
      ClusterPays: {
        redirectUrl: "/casino/ezgne-aloha-cluster-pays",
        code: "1100033",
        casino: "ezugi",
        providerName: "NetEnt",
        homeUrl: pageUrlGenerator("/slots"),
        imgUrl: "./images/slots/Aloha-Cluster-Pays.jpg",
        alt: "Aloha! Cluster Pays",
        name: "Aloha! Cluster Pays",
      },
      WildWest: {
        redirectUrl: "/casino/ezgne-wild-wild-west-the-great-train-heist",
        code: "1100038",
        casino: "ezugi",
        providerName: "NetEnt",
        homeUrl: pageUrlGenerator("/slots"),
        imgUrl: "./images/slots/Wild-Wild-West-The-Great-Train-Heist.jpg",
        alt: "Wild Wild West: The Great Train Heist",
        name: "Wild Wild West: The Great Train Heist",
      },
      TwinSpinMegaways: {
        redirectUrl: "/casino/ezgne-twin-spin-megaways",
        code: "1100039",
        casino: "ezugi",
        providerName: "NetEnt",
        homeUrl: pageUrlGenerator("/slots"),
        imgUrl: "./images/slots/Twin_Spin_Megaways.jpg",
        alt: "Twin Spin Megaways",
        name: "Twin Spin Megaways",
      },
      TurnFortune: {
        redirectUrl: "/casino/ezgne-turn-your-fortune",
        code: "1100041",
        casino: "ezugi",
        providerName: "NetEnt",
        homeUrl: pageUrlGenerator("/slots"),
        imgUrl: "./images/slots/Turn_Your_Fortune.jpg",
        alt: "Turn Your Fortune",
        name: "Turn Your Fortune",
      },
      Pyramid: {
        redirectUrl: "/casino/ezgne-pyramid-quest-for-immortality",
        code: "1100078",
        casino: "ezugi",
        providerName: "NetEnt",
        homeUrl: pageUrlGenerator("/slots"),
        imgUrl: "./images/slots/Pyramid-Quest-for-Immortality.jpg",
        alt: "Pyramid: Quest for Immortality",
        name: "Pyramid: Quest for Immortality",
      },
      PiggyRiches: {
        redirectUrl: "/casino/ezgne-piggy-riches",
        code: "1100080",
        casino: "ezugi",
        imgUrl: "./images/slots/Piggy-Riches.jpg",
        homeUrl: pageUrlGenerator("/slots"),
        name: "Piggy Riches",
      },
      DarkKing: {
        redirectUrl: "/casino/ezgne-dark-king-forbidden-riches",
        code: "1100081",
        casino: "ezugi",
        providerName: "NetEnt",
        homeUrl: pageUrlGenerator("/slots"),
        imgUrl: "./images/slots/Dark-King-Forbidden-Riches.jpg",
        alt: "Dark King: Forbidden Riches",
        name: "Dark King: Forbidden Riches",
      },
      JingleSpin: {
        redirectUrl: "/casino/ezgne-jingle-spin",
        code: "1100082",
        casino: "ezugi",
        providerName: "NetEnt",
        homeUrl: pageUrlGenerator("/slots"),
        imgUrl: "./images/slots/Jingle-Spin.jpg",
        alt: "Jingle Spin",
        name: "Jingle Spin",
      },
      JackHammer: {
        redirectUrl: "/casino/ezgne-jack-hammer",
        code: "1100084",
        casino: "ezugi",
        providerName: "NetEnt",
        homeUrl: pageUrlGenerator("/slots"),
        imgUrl: "./images/slots/Jack-Hammer.jpg",
        alt: "Jack Hammer",
        name: "Jack Hammer",
      },
      DeadorAlive: {
        redirectUrl: "/casino/ezgne-dead-or-alive",
        code: "1100085",
        casino: "ezugi",
        providerName: "NetEnt",
        homeUrl: pageUrlGenerator("/slots"),
        imgUrl: "./images/slots/Dead-or-Alive.jpg",
        alt: "Dead or Alive",
        name: "Dead or Alive",
      },
      DeadorAlive2: {
        redirectUrl: "/casino/ezgne-dead-or-alive-2",
        code: "1100087",
        casino: "ezugi",
        providerName: "NetEnt",
        homeUrl: pageUrlGenerator("/slots"),
        imgUrl: "./images/slots/Dead-or-Alive-2.jpg",
        alt: "Dead or Alive 2",
        name: "Dead or Alive 2",
      },
      JackandtheBeanstalk: {
        redirectUrl: "/casino/ezgne-jack-and-the-beanstalk",
        code: "1100086",
        casino: "ezugi",
        providerName: "NetEnt",
        homeUrl: pageUrlGenerator("/slots"),
        imgUrl: "./images/slots/Jack-and-the-Beanstalk.jpg",
        alt: "Jack and the Beanstalk",
        name: "Jack and the Beanstalk",
      },
      Elements: {
        redirectUrl: "/casino/ezgne-elements-the-awakening",
        code: "1100091",
        casino: "ezugi",
        providerName: "NetEnt",
        homeUrl: pageUrlGenerator("/slots"),
        imgUrl: "./images/slots/Elements-The-Awakening.jpg",
        alt: "Elements: The Awakening",
        name: "Elements: The Awakening",
      },
      FinnandtheSwirlySpin: {
        redirectUrl: "/casino/ezgne-finn-and-the-swirly-spin",
        code: "1100093",
        casino: "ezugi",
        providerName: "NetEnt",
        homeUrl: pageUrlGenerator("/slots"),
        imgUrl: "./images/slots/Finn-and-the-Swirly-Spin.jpg",
        alt: "Finn and the Swirly Spin",
        name: "Finn and the Swirly Spin",
      },
      FruitShop: {
        redirectUrl: "/casino/ezgne-fruit-shop",
        code: "1100095",
        casino: "ezugi",
        providerName: "NetEnt",
        homeUrl: pageUrlGenerator("/slots"),
        imgUrl: "./images/slots/Fruit-Shop.jpg",
        alt: "Fruit Shop",
        name: "Fruit Shop",
      },
      DeadorAlive2FeatureBuy: {
        redirectUrl: "/casino/ezgne-dead-or-alive-2-feature-buy",
        code: "1100100",
        casino: "ezugi",
        providerName: "NetEnt",
        homeUrl: pageUrlGenerator("/slots"),
        imgUrl: "./images/slots/Dead-or-Alive-2-Feature-Buy.jpg",
        alt: "Dead or Alive 2 Feature Buy",
        name: "Dead or Alive 2 Feature Buy",
      },
    },
    name: "Netent",
    key: "netent",
  },

  redtigertab: {
    slide1: {
      DragonsLuck: {
        href: "/casino/ezgrt-dragons-luck",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/DragonsLuck.webp",
        alt: "Dragon's Luck",
        name: "Dragon's Luck",
      },
      DragonsLuckPowerReels: {
        href: "/casino/ezgrt-dragons-luck-power-reels",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/DragonsLuckPowerReels.webp",
        alt: "Dragon's Luck Power Reels",
        name: "Dragon's Luck Power Reels",
      },
      Nights10001: {
        href: "/casino/ezgrt-10001-nights",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/10001Nights.webp",
        alt: "10,001 Nights",
        name: "10,001 Nights",
      },
      GodOfWealth: {
        href: "/casino/ezgrt-god-of-wealth",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/GodOfWealth.webp",
        alt: "God Of Wealth",
        name: "God Of Wealth",
      },
      PiratesPlentyBattleforGold: {
        href: "/casino/ezgrt-pirates-plenty-battle-for-gold",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/PiratesPlentyBattleforGold.webp",
        alt: "Pirates' Plenty Battle for Gold",
        name: "Pirates' Plenty Battle for Gold",
      },
      ChineseTreasures: {
        href: "/casino/ezgrt-chinese-treasures",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/ChineseTreasures.webp",
        alt: "Chinese Treasures",
        name: "Chinese Treasures",
      },
      FortuneHouse: {
        href: "/casino/ezgrt-fortune-house",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/FortuneHouse.webp",
        alt: "Fortune House",
        name: "Fortune House",
      },
      DragonsFire: {
        href: "/casino/ezgrt-dragons-fire",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/DragonsFire.webp",
        alt: "Dragon's Fire",
        name: "Dragon's Fire",
      },
      MagicGate: {
        href: "/casino/ezgrt-magic-gate",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/MagicGate.webp",
        alt: "Magic Gate",
        name: "Magic Gate",
      },
      LuckyFortuneCat: {
        href: "/casino/ezgrt-lucky-fortune-cat",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/LuckyFortuneCat.webp",
        alt: "Lucky Fortune Cat",
        name: "Lucky Fortune Cat",
      },
      DragonsLuckDeluxe: {
        href: "/casino/ezgrt-dragons-luck-deluxe",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/DragonsLuckDeluxe.webp",
        alt: "Dragon's Luck Deluxe",
        name: "Dragon's Luck Deluxe",
      },
      EpicJourney: {
        href: "/casino/ezgrt-epic-journey",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/EpicJourney.webp",
        alt: "Epic Journey",
        name: "Epic Journey",
      },
      PhoenixFirePowerReels: {
        href: "/casino/ezgrt-phoenix-fire-power-reels",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/PhoenixFirePowerReels.webp",
        alt: "Phoenix Fire Power Reels",
        name: "Phoenix Fire Power Reels",
      },
      TreasureMine: {
        href: "/casino/ezgrt-treasure-mine",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "mines",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/TreasureMine.webp",
        alt: "Treasure Mine",
        name: "Treasure Mine",
      },
      GoldenTemple: {
        href: "/casino/ezgrt-golden-temple",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/GoldenTemple.webp",
        alt: "Golden Temple",
        name: "Golden Temple",
      },
      PiratesPlenty: {
        href: "/casino/ezgrt-pirates-plenty",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/PiratesPlenty.webp",
        alt: "Pirates' Plenty",
        name: "Pirates' Plenty",
      },
      GoldenOffer: {
        href: "/casino/ezgrt-golden-offer",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/GoldenOffer.webp",
        alt: "Golden Offer",
        name: "Golden Offer",
      },
      RAsLegend: {
        href: "/casino/ezgrt-ras-legend",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/RAsLegend.webp",
        alt: "RA's Legend",
        name: "RA's Legend",
      },
      GonzosQuestMegaways: {
        href: "/casino/ezgrt-gonzos-quest-megaways",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/GonzosQuestMegaways.webp",
        alt: "Gonzo's Quest Megaways",
        name: "Gonzo's Quest Megaways",
      },
      RainbowJackpots: {
        href: "/casino/ezgrt-rainbow-jackpots",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/RainbowJackpots.webp",
        alt: "Rainbow Jackpots",
        name: "Rainbow Jackpots",
      },
      MegaPyramid: {
        href: "/casino/ezgrt-mega-pyramid",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/MegaPyramid.webp",
        alt: "Mega Pyramid",
        name: "Mega Pyramid",
      },
      WarOfGods: {
        href: "/casino/ezgrt-war-of-gods",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/WarOfGods.webp",
        alt: "War Of Gods",
        name: "War Of Gods",
      },
      Strike777: {
        href: "/casino/ezgrt-777-strike",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/777Strike.webp",
        alt: "777 Strike",
        name: "777 Strike",
      },
      AncientsBlessing: {
        href: "/casino/ezgrt-ancients-blessing",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/AncientsBlessing.webp",
        alt: "Ancients Blessing",
        name: "Ancients Blessing",
      },
      AurumCodex: {
        href: "/casino/ezgrt-aurum-codex",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/AurumCodex.webp",
        alt: "Aurum Codex",
        name: "Aurum Codex",
      },
      BettyBorisandBoo: {
        href: "/casino/ezgrt-betty-boris-and-boo",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/BettyBorisandBoo.webp",
        alt: "Betty, Boris and Boo",
        name: "Betty, Boris and Boo",
      },
      ZeusLightningPowerReels: {
        href: "/casino/ezgrt-zeus-lightning-power-reels",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/ZeusLightningPowerReels.webp",
        alt: "Zeus Lightning Power Reels",
        name: "Zeus Lightning Power Reels",
      },
      WingsofRa: {
        href: "/casino/ezgrt-wings-of-ra",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/WingsofRa.webp",
        alt: "Wings of Ra",
        name: "Wings of Ra",
      },
      ThorsVengeance: {
        href: "/casino/ezgrt-thors-vengeance",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/ThorsVengeance.webp",
        alt: "Thor's Vengeance",
        name: "Thor's Vengeance",
      },
      RegalStreak: {
        href: "/casino/ezgrt-regal-streak",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/RegalStreak.webp",
        alt: "Regal Streak",
        name: "Regal Streak",
      },
      RegalBeasts: {
        href: "/casino/ezgrt-regal-beasts",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/RegalBeasts.webp",
        alt: "Regal Beasts",
        name: "Regal Beasts",
      },
      ReelKingMega: {
        href: "/casino/ezgrt-reel-king-mega",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/ReelKingMega.webp",
        alt: "Reel King Mega",
        name: "Reel King Mega",
      },
      ReelKeeper: {
        href: "/casino/ezgrt-reel-keeper",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/ReelKeeper.webp",
        alt: "Reel Keeper",
        name: "Reel Keeper",
      },
      RainbowJackpotsPowerLines: {
        href: "/casino/ezgrt-rainbow-jackpots-power-lines",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/RainbowJackpotsPowerLines.webp",
        alt: "Rainbow Jackpots Power Lines",
        name: "Rainbow Jackpots Power Lines",
      },
      MysteryReels: {
        href: "/casino/ezgrt-mystery-reels",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/MysteryReels.webp",
        alt: "Mystery Reels",
        name: "Mystery Reels",
      },
      PiggyRichesMegaways: {
        href: "/casino/ezgrt-piggy-riches-megaways",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/PiggyRichesMegaways.webp",
        alt: "Piggy Riches Megaways",
        name: "Piggy Riches Megaways",
      },
      JingleBells: {
        href: "/casino/ezgrt-jingle-bells",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/JingleBells.webp",
        alt: "Jingle Bells",
        name: "Jingle Bells",
      },
      JackinaPot: {
        href: "/casino/ezgrt-jack-in-a-pot",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/JackinaPot.webp",
        alt: "Jack in a Pot",
        name: "Jack in a Pot",
      },
      FiveStar: {
        href: "/casino/ezgrt-five-star",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/FiveStar.webp",
        alt: "Five Star",
        name: "Five Star",
      },
      BountyRaid: {
        href: "/casino/ezgrt-bounty-raid",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/BountyRaid.webp",
        alt: "Bounty Raid",
        name: "Bounty Raid",
      },
      CashUltimate: {
        href: "/casino/ezgrt-cash-ultimate",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/CashUltimate.webp",
        alt: "Cash Ultimate",
        name: "Cash Ultimate",
      },
      CashVolt: {
        href: "/casino/ezgrt-cash-volt",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/CashVolt.webp",
        alt: "Cash Volt",
        name: "Cash Volt",
      },
      DynamiteRiches: {
        href: "/casino/ezgrt-dynamite-riches",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/DynamiteRiches.webp",
        alt: "Dynamite Riches",
        name: "Dynamite Riches",
      },
      DiamondBlitz: {
        href: "/casino/ezgrt-diamond-blitz",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/DiamondBlitz.webp",
        alt: "Diamond Blitz",
        name: "Diamond Blitz",
      },
      DragonsFireMegaways: {
        href: "/casino/ezgrt-dragons-fire-megaways",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/DragonsFireMegaways.webp",
        alt: "Dragon's Fire Megaways",
        name: "Dragon's Fire Megaways",
      },
      Squad4: {
        href: "/casino/ezgrt-4-squad",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/4Squad.webp",
        alt: "4 Squad",
        name: "4 Squad",
      },
      AgentRoyale: {
        href: "/casino/ezgrt-agent-royale",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/AgentRoyale.webp",
        alt: "Agent Royale",
        name: "Agent Royale",
      },
      Families5: {
        href: "/casino/ezgrt-5-families",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/5Families.webp",
        alt: "5 Families",
        name: "5 Families",
      },
      ArcadeBomb: {
        href: "/casino/ezgrt-arcade-bomb",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/ArcadeBomb.webp",
        alt: "Arcade Bomb",
        name: "Arcade Bomb",
      },
      CinderellasBall: {
        href: "/casino/ezgrt-cinderellas-ball",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/CinderellasBall.webp",
        alt: "Cinderella`s Ball",
        name: "Cinderella`s Ball",
      },
      Atlantis: {
        href: "/casino/ezgrt-atlantis",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/Atlantis.webp",
        alt: "Atlantis",
        name: "Atlantis",
      },
      AztecSpins: {
        href: "/casino/ezgrt-aztec-spins",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/AztecSpins.webp",
        alt: "Aztec Spins",
        name: "Aztec Spins",
      },
      ClashoftheBeasts: {
        href: "/casino/ezgrt-clash-of-the-beasts",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/ClashoftheBeasts.webp",
        alt: "Clash of the Beasts",
        name: "Clash of the Beasts",
      },
      CirquedelaFortune: {
        href: "/casino/ezgrt-cirque-de-la-fortune",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/CirquedelaFortune.webp",
        alt: "Cirque de la Fortune",
        name: "Cirque de la Fortune",
      },
      CrazyGenie: {
        href: "/casino/ezgrt-crazy-genie",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/CrazyGenie.webp",
        alt: "Crazy Genie",
        name: "Crazy Genie",
      },
      CrystalMirror: {
        href: "/casino/ezgrt-crystal-mirror",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/CrystalMirror.webp",
        alt: "Crystal Mirror",
        name: "Crystal Mirror",
      },
      DevilsNumber: {
        href: "/casino/ezgrt-devils-number",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/DevilsNumber.webp",
        alt: "Devil`s Number",
        name: "Devil`s Number",
      },
      DaVincisMystery: {
        href: "/casino/ezgrt-da-vincis-mystery",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/DaVincisMystery.webp",
        alt: "Da Vinci`s Mystery",
        name: "Da Vinci`s Mystery",
      },
      DiceDiceDice: {
        href: "/casino/ezgrt-dice-dice-dice",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/DiceDiceDice.webp",
        alt: "Dice Dice Dice",
        name: "Dice Dice Dice",
      },
      FiveStarsPowerReels: {
        href: "/casino/ezgrt-five-stars-power-reels",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/FiveStarsPowerReels.webp",
        alt: "Five Stars Power Reels",
        name: "Five Stars Power Reels",
      },
      GemsGoneWild: {
        href: "/casino/ezgrt-gems-gone-wild",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/GemsGoneWild.webp",
        alt: "Gems Gone Wild",
        name: "Gems Gone Wild",
      },
      GemsGoneWildPowerReels: {
        href: "/casino/ezgrt-gems-gone-wild-power-reels",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/GemsGoneWildPowerReels.webp",
        alt: "Gems Gone Wild Power Reels",
        name: "Gems Gone Wild Power Reels",
      },
      GoldenCryptex: {
        href: "/casino/ezgrt-golden-cryptex",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/GoldenCryptex.webp",
        alt: "Golden Cryptex",
        name: "Golden Cryptex",
      },
      GoldenLeprechaunMegaways: {
        href: "/casino/ezgrt-golden-leprechaun-megaways",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/GoldenLeprechaunMegaways.webp",
        alt: "Golden Leprechaun Megaways",
        name: "Golden Leprechaun Megaways",
      },
      GrandWheel: {
        href: "/casino/ezgrt-grand-wheel",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/GrandWheel.webp",
        alt: "Grand Wheel",
        name: "Grand Wheel",
      },
      GoldenTsar: {
        href: "/casino/ezgrt-golden-tsar",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/GoldenTsar.webp",
        alt: "Golden Tsar",
        name: "Golden Tsar",
      },
      HoardofPoseidon: {
        href: "/casino/ezgrt-hoard-of-poseidon",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/HoardofPoseidon.webp",
        alt: "Hoard of Poseidon",
        name: "Hoard of Poseidon",
      },
      JewelScarabs: {
        href: "/casino/ezgrt-jewel-scarabs",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/JewelScarabs.webp",
        alt: "Jewel Scarabs",
        name: "Jewel Scarabs",
      },
      LegendofAthena: {
        href: "/casino/ezgrt-legend-of-athena",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/LegendofAthena.webp",
        alt: "Legend of Athena",
        name: "Legend of Athena",
      },
      JingleBellsPowerReels: {
        href: "/casino/ezgrt-jingle-bells-power-reels",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/JingleBellsPowerReels.webp",
        alt: "Jingle Bells Power Reels",
        name: "Jingle Bells Power Reels",
      },
      LuckyHalloween: {
        href: "/casino/ezgrt-lucky-halloween",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/LuckyHalloween.webp",
        alt: "Lucky Halloween",
        name: "Lucky Halloween",
      },
      LuckyLittleDevil: {
        href: "/casino/ezgrt-lucky-little-devil",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/LuckyLittleDevil.webp",
        alt: "Lucky Little Devil",
        name: "Lucky Little Devil",
      },
      LuckyValentine: {
        href: "/casino/ezgrt-lucky-valentine",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/LuckyValentine.webp",
        alt: "Lucky Valentine",
        name: "Lucky Valentine",
      },
      LuckyWizard: {
        href: "/casino/ezgrt-lucky-wizard",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/LuckyWizard.webp",
        alt: "Lucky Wizard",
        name: "Lucky Wizard",
      },
      Masquerade: {
        href: "/casino/ezgrt-masquerade",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/Masquerade.webp",
        alt: "Masquerade",
        name: "Masquerade",
      },
      MayanGods: {
        href: "/casino/ezgrt-mayan-gods",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/MayanGods.webp",
        alt: "Mayan Gods",
        name: "Mayan Gods",
      },
      MegaDragon: {
        href: "/casino/ezgrt-mega-dragon",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/MegaDragon.webp",
        alt: "Mega Dragon",
        name: "Mega Dragon",
      },
      MegaJade: {
        href: "/casino/ezgrt-mega-jade",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/MegaJade.webp",
        alt: "Mega Jade",
        name: "Mega Jade",
      },
      MegaRise: {
        href: "/casino/ezgrt-mega-rise",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/MegaRise.webp",
        alt: "Mega Rise",
        name: "Mega Rise",
      },
      MultiplierRiches: {
        href: "/casino/ezgrt-multiplier-riches",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/MultiplierRiches.webp",
        alt: "Multiplier Riches",
        name: "Multiplier Riches",
      },
      MysteryReelsMegaways: {
        href: "/casino/ezgrt-mystery-reels-megaways",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/MysteryReelsMegaways.webp",
        alt: "Mystery Reels Megaways",
        name: "Mystery Reels Megaways",
      },
      NinjaWays: {
        href: "/casino/ezgrt-ninja-ways",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/NinjaWays.webp",
        alt: "Ninja Ways",
        name: "Ninja Ways",
      },
      PathofDestiny: {
        href: "/casino/ezgrt-path-of-destiny",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/PathofDestiny.webp",
        alt: "Path of Destiny",
        name: "Path of Destiny",
      },
      PersianFortune: {
        href: "/casino/ezgrt-persian-fortune",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/PersianFortune.webp",
        alt: "Persian Fortune",
        name: "Persian Fortune",
      },
      ReelHeist: {
        href: "/casino/ezgrt-reel-heist",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/ReelHeist.webp",
        alt: "Reel Heist",
        name: "Reel Heist",
      },
      RobinHoodsWildForest: {
        href: "/casino/ezgrt-robin-hoods-wild-forest",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/RobinHoodsWildForest.webp",
        alt: "Robin Hood`s Wild Forest",
        name: "Robin Hood`s Wild Forest",
      },
      SnowWildAndThe7Features: {
        href: "/casino/ezgrt-snow-wild-and-the-7-features",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/SnowWildAndThe7Features.webp",
        alt: "Snow Wild And The 7 Features",
        name: "Snow Wild And The 7 Features",
      },
      SylvanSpirits: {
        href: "/casino/ezgrt-sylvan-spirits",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/SylvanSpirits.webp",
        alt: "Sylvan Spirits",
        name: "Sylvan Spirits",
      },
      TheGreatestTrainRobbery: {
        href: "/casino/ezgrt-the-greatest-train-robbery",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/TheGreatestTrainRobbery.webp",
        alt: "The Greatest Train Robbery",
        name: "The Greatest Train Robbery",
      },
      TheWildHatter: {
        href: "/casino/ezgrt-the-wild-hatter",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/TheWildHatter.webp",
        alt: "The Wild Hatter",
        name: "The Wild Hatter",
      },
      ThorsLightning: {
        href: "/casino/ezgrt-thors-lightning",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/ThorsLightning.webp",
        alt: "Thor`s Lightning",
        name: "Thor`s Lightning",
      },
      TikiFruits: {
        href: "/casino/ezgrt-tiki-fruits",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/TikiFruits.webp",
        alt: "Tiki Fruits",
        name: "Tiki Fruits",
      },
      VaultCracker: {
        href: "/casino/ezgrt-vault-cracker",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/VaultCracker.webp",
        alt: "Vault Cracker",
        name: "Vault Cracker",
      },
      TotemLightning: {
        href: "/casino/ezgrt-totem-lightning",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/TotemLightning.webp",
        alt: "Totem Lightning",
        name: "Totem Lightning",
      },
      WellofWishes: {
        href: "/casino/ezgrt-well-of-wishes",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/WellofWishes.webp",
        alt: "Well of Wishes",
        name: "Well of Wishes",
      },
      VaultofAnubis: {
        href: "/casino/ezgrt-vault-of-anubis",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/VaultofAnubis.webp",
        alt: "Vault of Anubis",
        name: "Vault of Anubis",
      },
      WildOClock: {
        href: "/casino/ezgrt-wild-oclock",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/WildOClock.webp",
        alt: "Wild O`Clock",
        name: "Wild O`Clock",
      },
      WildCatsMultiline: {
        href: "/casino/ezgrt-wild-cats-multiline",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/WildCatsMultiline.webp",
        alt: "Wild Cats Multiline",
        name: "Wild Cats Multiline",
      },
      YucatansMystery: {
        href: "/casino/ezgrt-yucatans-mystery",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/YucatansMystery.webp",
        alt: "Yucatan`s Mystery",
        name: "Yucatan`s Mystery",
      },
      WildWildChest: {
        href: "/casino/ezgrt-wild-wild-chest",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/WildWildChest.webp",
        alt: "Wild Wild Chest",
        name: "Wild Wild Chest",
      },
      WinEscalator: {
        href: "/casino/ezgrt-win-escalator",
        code: "",
        casino: "ezugi",
        provider: "RedTiger",
        category: "redtiger",
        homeUrl: "/slots-games",
        imgUrl: "/images/slots/redtiger/WinEscalator.webp",
        alt: "Win Escalator",
        name: "Win Escalator",
      },
    },
    name: "Red Tiger",
    key: "redTiger",
  },

  ezugislots: {
    slide1: {
      ezmarbleracemo: {
        redirectUrl: "/casino/aggapezugi-ez-marble-race-monaco",
        code: "",
        casino: "ezugi",
        provider: "",
        homeUrl: pageUrlGenerator("/home"),
        imgUrl: "./images/spribe/ezmarbleracemo.webp",
        alt: "EZ Marble Race Monaco",
        name: "EZ Marble Race Monaco",
      },
    },
    name: "Ezugi Slots",
    key: "ezugislots",
  },

  jili: {
    slide1: {
      Coin3Treasures: {
        redirectUrl: "/casino/aggapjiligaming-3-coin-treasures",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/3-coin-treasures.webp",
        alt: "3 coin treasures",
        name: "3 coin treasures",
      },
      Lucky3Piggy: {
        redirectUrl: "/casino/aggapjiligaming-3-lucky-piggy",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/3-lucky-piggy.webp",
        alt: "3 lucky piggy",
        name: "3 lucky piggy",
      },
      Pot3Dragons: {
        redirectUrl: "/casino/aggapjiligaming-3-pot-dragons",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/3-pot-dragons.webp",
        alt: "3 pot dragons",
        name: "3 pot dragons",
      },
      AgentAce: {
        redirectUrl: "/casino/aggapjiligaming-agent-ace",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/agent-ace.webp",
        alt: "agent ace",
        name: "agent ace",
      },
      AliBaba: {
        redirectUrl: "/casino/aggapjiligaming-ali-baba",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/ali-baba.webp",
        alt: "ali baba",
        name: "ali baba",
      },
      ArenaFighter: {
        redirectUrl: "/casino/aggapjiligaming-arena-fighter",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/arena-fighter.webp",
        alt: "arena fighter",
        name: "arena fighter",
      },
      AztecPriestess: {
        redirectUrl: "/casino/aggapjiligaming-aztec-priestess",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/aztec-priestess.webp",
        alt: "aztec priestess",
        name: "aztec priestess",
      },
      BanglaBeauty: {
        redirectUrl: "/casino/aggapjiligaming-bangla-beauty",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/bangla-beauty.webp",
        alt: "bangla beauty",
        name: "bangla beauty",
      },
      BaoBoonChin: {
        redirectUrl: "/casino/aggapjiligaming-bao-boon-chin",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/bao-boon-chin.webp",
        alt: "bao boon chin",
        name: "bao boon chin",
      },
      BoneFortune: {
        redirectUrl: "/casino/aggapjiligaming-bone-fortune",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/bone-fortune.webp",
        alt: "bone fortune",
        name: "bone fortune",
      },
      BonusHunter: {
        redirectUrl: "/casino/aggapjiligaming-bonus-hunter",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/bonus-hunter.webp",
        alt: "bonus h1unter",
        name: "bonus hunter",
      },
      BookOfGold: {
        redirectUrl: "/casino/aggapjiligaming-book-of-gold",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/book-of-gold.webp",
        alt: "book of gold",
        name: "book of gold",
      },
      BoxingKing: {
        redirectUrl: "/casino/aggapjiligaming-boxing-king",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/boxing-king.webp",
        alt: "boxing king",
        name: "boxing king",
      },
      BubbleBeauty: {
        redirectUrl: "/casino/aggapjiligaming-bubble-beauty",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/bubble-beauty.webp",
        alt: "bubble beauty",
        name: "bubble beauty",
      },
      CargeBuffalo: {
        redirectUrl: "/casino/aggapjiligaming-charge-buffalo",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/charge-buffalo.webp",
        alt: "charge buffalo",
        name: "charge buffalo",
      },
      ChargeBuffaloAscent: {
        redirectUrl: "/casino/aggapjiligaming-charge-buffalo-ascent",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/charge-buffalo-ascent.webp",
        alt: "charge buffalo ascent",
        name: "charge buffalo ascent",
      },
      Chinshihuang: {
        redirectUrl: "/casino/aggapjiligaming-chin-shi-huang",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/chin-shi-huang.webp",
        alt: "",
        name: "Chin Shi Huang",
      },
      CrazyFafafa: {
        redirectUrl: "/casino/aggapjiligaming-crazy-fafafa",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/crazy-fafafa.webp",
        alt: "crazy fafafa",
        name: "crazy fafafa",
      },
      CrazyHunter: {
        redirectUrl: "/casino/aggapjiligaming-crazy-hunter",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/crazy-hunter.webp",
        alt: "crazy hunter",
        name: "crazy hunter",
      },
      Crazy777: {
        redirectUrl: "/casino/aggapjiligaming-crazy777",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/crazy777.webp",
        alt: "",
        name: "Crazy777",
      },
      CricketKing18: {
        redirectUrl: "/casino/aggapjiligaming-cricket-king-18",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/cricket-king-18.webp",
        alt: "cricket king 18",
        name: "cricket king 18",
      },
      CricketSah75: {
        redirectUrl: "/casino/aggapjiligaming-cricket-sah-75",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/cricket-sah-75.webp",
        alt: "cricket sah 75",
        name: "cricket sah 75",
      },
      Dabanggg: {
        redirectUrl: "/casino/aggapjiligaming-dabanggg",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/dabanggg.webp",
        alt: "dabanggg",
        name: "dabanggg",
      },
      DevilFire2: {
        redirectUrl: "/casino/aggapjiligaming-devil-fire-2",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/devil-fire-2.webp",
        alt: "devil fire 2",
        name: "devil fire 2",
      },
      DiamondParty: {
        redirectUrl: "/casino/aggapjiligaming-diamondparty",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/diamond-party.webp",
        alt: "diamond party",
        name: "diamond party",
      },
      DragonTreasure: {
        redirectUrl: "/casino/aggapjiligaming-dragon-treasure",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/dragon-treasure.webp",
        alt: "dragon treasure",
        name: "dragon treasure",
      },
      EgyptsGlow: {
        redirectUrl: "/casino/aggapjiligaming-egypts-glow",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/egypts-glow.webp",
        alt: "egypt's glow",
        name: "egypt's glow",
      },
      FaFaFa: {
        redirectUrl: "/casino/aggapjiligaming-fa-fa-fa",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/fa-fa-fa.webp",
        alt: "fa fa fa",
        name: "fa fa fa",
      },
      Fengshen: {
        redirectUrl: "/casino/aggapjiligaming-fengshen",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/fengshen.webp",
        alt: "fengshen",
        name: "fengshen",
      },
      FortuneGems: {
        redirectUrl: "/casino/aggapjiligaming-fortune-gems",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/fortune-gems.webp",
        alt: "fortune gems",
        name: "fortune gems",
      },
      FortuneGems2: {
        redirectUrl: "/casino/aggapjiligaming-fortune-gems-2",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/fortune-gems-2.webp",
        alt: "fortune gems 2",
        name: "fortune gems 2",
      },
      FortuneGems3: {
        redirectUrl: "/casino/aggapjiligaming-fortune-gems-3",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/fortune-gems-3.webp",
        alt: "fortune gems 3",
        name: "fortune gems 3",
      },
      FortuneMonkey: {
        redirectUrl: "/casino/aggapjiligaming-fortune-monkey",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/fortune-monkey.webp",
        alt: "fortune monkey",
        name: "fortune monkey",
      },
      FortuneTree: {
        redirectUrl: "/casino/aggapjiligaming-fortune-tree",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/fortune-tree.webp",
        alt: "",
        name: "Fortune Tree",
      },
      GemParty: {
        redirectUrl: "/casino/aggapjiligaming-gem-party",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/gem-party.webp",
        alt: "",
        name: "Gem Party",
      },
      GodOfMartial: {
        redirectUrl: "/casino/aggapjiligaming-god-of-martial",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/god-of-martial.webp",
        alt: "",
        name: "God Of Martial",
      },
      GoldRush: {
        redirectUrl: "/casino/aggapjiligaming-gold-rush",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/gold-rush.webp",
        alt: "gold rush",
        name: "gold rush",
      },
      GoldenBank: {
        redirectUrl: "/casino/aggapjiligaming-crazy-golden-bank",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/golden-bank.webp",
        alt: "golden bank",
        name: "golden bank",
      },
      GoldenEmpire: {
        redirectUrl: "/casino/aggapjiligaming-golden-empire",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/golden-empire.webp",
        alt: "golden empire",
        name: "golden empire",
      },
      GoldenJoker: {
        redirectUrl: "/casino/aggapjiligaming-golden-joker",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/golden-joker.webp",
        alt: "golden joker",
        name: "golden joker",
      },
      GoldenQueen: {
        redirectUrl: "/casino/aggapjiligaming-golden-queen",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/golden-queen.webp",
        alt: "golden queen",
        name: "golden queen",
      },
      GoldenTemple: {
        redirectUrl: "/casino/aggapjiligaming-golden-temple",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/golden-temple.webp",
        alt: "golden temple",
        name: "golden temple",
      },
      HappyTaxi: {
        redirectUrl: "/casino/aggapjiligaming-happy-taxi",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/happy-taxi.webp",
        alt: "happy taxi",
        name: "happy taxi",
      },
      HawaiiBeauty: {
        redirectUrl: "/casino/aggapjiligaming-hawaii-beauty",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/hawaii-beauty.webp",
        alt: "hawaii beauty",
        name: "hawaii beauty",
      },
      HotChili: {
        redirectUrl: "/casino/aggapjiligaming-hot-chilli",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/hot-chilli.webp",
        alt: "Hot Chilli",
        name: "Hot Chilli",
      },
      HyperBrust: {
        redirectUrl: "/casino/aggapjiligaming-hyper-burst",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/hyper-burst.webp",
        alt: "Hyper Burst",
        name: "Hyper Burst",
      },
      JiliCaishen: {
        redirectUrl: "/casino/aggapjiligaming-jili-caishen",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/jili-caishen.webp",
        alt: "jili caishen",
        name: "jili caishen",
      },
      JungleKing: {
        redirectUrl: "/casino/aggapjiligaming-jungle-king",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/jungle-king.webp",
        alt: "jungle king",
        name: "jungle king",
      },
      KingArthur: {
        redirectUrl: "/casino/aggapjiligaming-king-arthur",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/king-arthur.webp",
        alt: "king arthur",
        name: "king arthur",
      },
      LegacyOfEgypt: {
        redirectUrl: "/casino/aggapjiligaming-legacy-of-egypt",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/legacy-of-egypt.webp",
        alt: "legacy of egypt",
        name: "legacy of egypt",
      },
      LuckyBall: {
        redirectUrl: "/casino/aggapjiligaming-lucky-ball",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/lucky-ball.webp",
        alt: "lucky ball",
        name: "lucky ball",
      },
      LuckyComing: {
        redirectUrl: "/casino/aggapjiligaming-lucky-coming",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/lucky-coming.webp",
        alt: "lucky coming",
        name: "lucky coming",
      },
      MagicLamp: {
        redirectUrl: "/casino/aggapjiligaming-magic-lamp",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/magic-lamp.webp",
        alt: "magic lamp",
        name: "magic lamp",
      },
      MasterTiger: {
        redirectUrl: "/casino/aggapjiligaming-master-tiger",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/master-tiger.webp",
        alt: "master tiger",
        name: "master tiger",
      },
      MayanEmpire: {
        redirectUrl: "/casino/aggapjiligaming-mayan-empire",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/mayan-empire.webp",
        alt: "mayan empire",
        name: "mayan empire",
      },
      Medusa: {
        redirectUrl: "/casino/aggapjiligaming-medusa",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/medusa.webp",
        alt: "medusa",
        name: "medusa",
      },
      MegaAce: {
        redirectUrl: "/casino/aggapjiligaming-mega-ace",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/mega-ace.webp",
        alt: "mega ace",
        name: "mega ace",
      },
      MoneyComing: {
        redirectUrl: "/casino/aggapjiligaming-money-coming",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/money-coming.webp",
        alt: "money coming",
        name: "money coming",
      },
      MoneyComingExpandedBets: {
        redirectUrl: "/casino/aggapjiligaming-money-coming-expand-bets",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/money-coming-expanded-bets.webp",
        alt: "money coming expanded bets",
        name: "money coming expanded bets",
      },
      MonkeyParty: {
        redirectUrl: "/casino/aggapjiligaming-monkey-party",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/monkey-party.webp",
        alt: "monkey party",
        name: "monkey party",
      },
      NekoFortune: {
        redirectUrl: "/casino/aggapjiligaming-neko-fortune",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/neko-fortune.webp",
        alt: "neko fortune",
        name: "neko fortune",
      },
      NightCity: {
        redirectUrl: "/casino/aggapjiligaming-night-city",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/night-city.webp",
        alt: "night city",
        name: "night city",
      },
      PartyNight: {
        redirectUrl: "/casino/aggapjiligaming-party-night",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/party-night.webp",
        alt: "party night",
        name: "party night",
      },
      PartyStar: {
        redirectUrl: "/casino/aggapjiligaming-party-star",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/party-star.webp",
        alt: "party star",
        name: "party star",
      },
      PharaohTreasure: {
        redirectUrl: "/casino/aggapjiligaming-pharaoh-treasure",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/pharaoh-treasure.webp",
        alt: "pharaoh treasure",
        name: "pharaoh treasure",
      },
      PirateQueen: {
        redirectUrl: "/casino/aggapjiligaming-pirate-queen",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/pirate-queen.webp",
        alt: "pirate queen",
        name: "pirate queen",
      },
      Poseidon: {
        redirectUrl: "/casino/aggapjiligaming-poseidon",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/poseidon.webp",
        alt: "poseidon",
        name: "poseidon",
      },
      PotionWizard: {
        redirectUrl: "/casino/aggapjiligaming-potion-wizard",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/potion-wizard.webp",
        alt: "potion wizard",
        name: "potion wizard",
      },
      RomaX: {
        redirectUrl: "/casino/aggapjiligaming-romax",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/roma-x.webp",
        alt: "romax",
        name: "romax",
      },
      Samba: {
        redirectUrl: "/casino/aggapjiligaming-samba",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/samba.webp",
        alt: "samba",
        name: "samba",
      },
      SecretTreasure: {
        redirectUrl: "/casino/aggapjiligaming-secret-treasure",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/secret-treasure.webp",
        alt: "secret treasure",
        name: "secret treasure",
      },
      ShanghaiBeauty: {
        redirectUrl: "/casino/aggapjiligaming-shanghai-beauty",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/shanghai-beauty.webp",
        alt: "Shanghai Beauty",
        name: "Shanghai Beauty",
      },
      SinCity: {
        redirectUrl: "/casino/aggapjiligaming-sin-city",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/sin-city.webp",
        alt: "sin city",
        name: "sin city",
      },
      SuperAce: {
        redirectUrl: "/casino/aggapjiligaming-super-ace",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/super-ace.webp",
        alt: "super ace",
        name: "super ace",
      },
      SuperAceDeluxe: {
        redirectUrl: "/casino/aggapjiligaming-super-ace-deluxe",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/super-ace-deluxe.webp",
        alt: "super ace deluxe",
        name: "super ace deluxe",
      },
      SuperRich: {
        redirectUrl: "/casino/aggapjiligaming-super-rich",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/super-rich.webp",
        alt: "super rich",
        name: "super rich",
      },
      SweetLand: {
        redirectUrl: "/casino/aggapjiligaming-sweet-land",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/sweet-land.webp",
        alt: "sweet land",
        name: "sweet land",
      },
      ThorX: {
        redirectUrl: "/casino/aggapjiligaming-thor-x",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/thor-x.webp",
        alt: "thor x",
        name: "thor x",
      },
      TrialOfPhoenix: {
        redirectUrl: "/casino/aggapjiligaming-trial-of-phoenix",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/trial-of-phoenix.webp",
        alt: "trial of phoenix",
        name: "trial of phoenix",
      },
      TwinWins: {
        redirectUrl: "/casino/aggapjiligaming-twin-wins",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/twin-wins.webp",
        alt: "twin wins",
        name: "twin wins",
      },
      WarOfDragons: {
        redirectUrl: "/casino/aggapjiligaming-war-of-dragons",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/war-of-dragons.webp",
        alt: "war of dragons",
        name: "war of dragons",
      },
      WildAce: {
        redirectUrl: "/casino/aggapjiligaming-wild-ace",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/wild-ace.webp",
        alt: "wild ace",
        name: "wild ace",
      },
      WildRacer: {
        redirectUrl: "/casino/aggapjiligaming-wild-racer",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/wild-racer.webp",
        alt: "wild racer",
        name: "wild racer",
      },
      WitchesNight: {
        redirectUrl: "/casino/aggapjiligaming-witches-night",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/witches-night.webp",
        alt: "witches night",
        name: "witches night",
      },
      WorldCup: {
        redirectUrl: "/casino/aggapjiligaming-world-cup",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/world-cup.webp",
        alt: "world cup",
        name: "world cup",
      },
      Xiyangyang: {
        redirectUrl: "/casino/aggapjiligaming-xiyangyang",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/xiyangyang.webp",
        alt: "xiyangyang",
        name: "xiyangyang",
      },
      Zeus: {
        redirectUrl: "/casino/aggapjiligaming-zeus",
        code: "",
        casino: "Slots",
        providerName: "Jili",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/jili/zeus.webp",
        alt: "zeus",
        name: "zeus",
      },
    },
    name: "Jili",
    key: "jili",
  },

  turbo: {
    slide1: {
      aero: {
        redirectUrl: "/casino/aggapturbogames-aero",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/Aero.webp",
        alt: "Aero",
        name: "Aero",
      },
      BallAndBall: {
        redirectUrl: "/casino/aggapturbogames-ball-and-ball",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/Ball&Ball.webp",
        alt: "Ball & Ball",
        name: "Ball & Ball",
      },
      Bayraktar: {
        redirectUrl: "/casino/aggapturbogames-bayraktar",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/Bayraktar.webp",
        alt: "Bayraktar",
        name: "Bayraktar",
      },
      Bubbles: {
        redirectUrl: "/casino/aggapturbogames-bubbles",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/Bubbles.webp",
        alt: "Bubbles",
        name: "Bubbles",
      },
      crashX: {
        redirectUrl: "/casino/aggapturbogames-crash-x",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/CrashX.webp",
        alt: "Crash X",
        name: "Crash X",
      },
      CrashXFootballEdition: {
        redirectUrl: "/casino/aggapturbogames-crash-x-football-edition",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/CrashXFootballEdition.webp",
        alt: "Crash X Football Edition",
        name: "Crash X Football Edition",
      },
      DiceTwice: {
        redirectUrl: "/casino/aggapturbogames-dice-twice",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/DiceTwice.webp",
        alt: "Dice Twice",
        name: "Dice Twice",
      },
      DogsStreet: {
        redirectUrl: "/casino/aggapturbogames-dogs-street",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/DogsStreet.webp",
        alt: "Dogs' Street",
        name: "Dogs' Street",
      },
      DoubleRoll: {
        redirectUrl: "/casino/aggapturbogames-double-roll",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/DoubleRoll.webp",
        alt: "Double Roll",
        name: "Double Roll",
      },
      FastFielder: {
        redirectUrl: "/casino/aggapturbogames-fast-fielder",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/FastFielder.webp",
        alt: "Fast Fielder",
        name: "Fast Fielder",
      },
      FruitTowers: {
        redirectUrl: "/casino/aggapturbogames-fruit-towers",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/FruitTowers.webp",
        alt: "Fruit Towers",
        name: "Fruit Towers",
      },
      Hamsta: {
        redirectUrl: "/casino/aggapturbogames-hamsta",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/Hamsta.webp",
        alt: "Hamsta",
        name: "Hamsta",
      },
      HiLo: {
        redirectUrl: "/casino/aggapturbogames-hi-lo",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/Hi-Lo.webp",
        alt: "Hi-Lo",
        name: "Hi-Lo",
      },
      JavelinX: {
        redirectUrl: "/casino/aggapturbogames-javelinx",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/JavelinX.webp",
        alt: "JavelinX",
        name: "JavelinX",
      },
      LimboRider: {
        redirectUrl: "/casino/aggapturbogames-limbo-rider",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/LimboRider.webp",
        alt: "Limbo Rider",
        name: "Limbo Rider",
      },
      Mines: {
        redirectUrl: "/casino/aggapturbogames-mines",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/Mines.webp",
        alt: "Mines",
        name: "Mines",
      },
      Neko: {
        redirectUrl: "/casino/aggapturbogames-neko",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/Neko.webp",
        alt: "Neko",
        name: "Neko",
      },
      SaveThePrincess: {
        redirectUrl: "/casino/aggapturbogames-save-the-princess",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/SaveThePrincess.webp",
        alt: "Save the Princess",
        name: "Save the Princess",
      },
      SpinStrike: {
        redirectUrl: "/casino/aggapturbogames-spin-strike",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/SpinStrike.webp",
        alt: "Spin Strike",
        name: "Spin Strike",
      },
      Stairs: {
        redirectUrl: "/casino/aggapturbogames-fury-stairs",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/Stairs.webp",
        alt: "Stairs",
        name: "Stairs",
      },
      TradingDice: {
        redirectUrl: "/casino/aggapturbogames-trading-dice",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/TradingDice.webp",
        alt: "Trading Dice",
        name: "Trading Dice",
      },
      Towers: {
        redirectUrl: "/casino/aggapturbogames-towers",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/Towers.webp",
        alt: "Towers",
        name: "Towers",
      },
      TurboMines: {
        redirectUrl: "/casino/aggapturbogames-turbo-mines",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/TurboMines.webp",
        alt: "Turbo Mines",
        name: "Turbo Mines",
      },
      TurboPlinko: {
        redirectUrl: "/casino/aggapturbogames-turbo-plinko",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/TurboPlinko.webp",
        alt: "Turbo Plinko",
        name: "Turbo Plinko",
      },
      WicketBlast: {
        redirectUrl: "/casino/aggapturbogames-wicket-blast",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/WicketBlast.webp",
        alt: "Wicket Blast",
        name: "Wicket Blast",
      },
      MagicKeno: {
        redirectUrl: "/casino/aggapturbogames-magic-keno",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/MagicKeno.webp",
        alt: "Magic Keno",
        name: "Magic Keno",
      },
      Vortex: {
        redirectUrl: "/casino/aggapturbogames-vortex",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/Vortex.webp",
        alt: "Vortex",
        name: "Vortex",
      },
      Tap1Mines: {
        redirectUrl: "/casino/aggapturbogames-1tap-mines",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/1TapMines(InstantWin).webp",
        alt: "1Tap Mines",
        name: "1Tap Mines",
      },
      TakeMyPlinko: {
        redirectUrl: "/casino/aggapturbogames-take-my-plinko",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/TakeMyPlinko.webp",
        alt: "Take My Plinko",
        name: "Take My Plinko",
      },
      Tap1MinesIW: {
        redirectUrl: "/casino/qt-1tap-mines",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/1TapMines.webp",
        alt: "1Tap Mines (Instant Win)",
        name: "1Tap Mines (Instant Win)",
      },
      DiceThrice: {
        redirectUrl: "/casino/aggapturbogames-dice-thrice",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/DiceThrice.webp",
        alt: "Dice Thrice",
        name: "Dice Thrice",
      },
      PumpedX: {
        redirectUrl: "/casino/aggapturbogames-pumpedx",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/PumpedX.webp",
        alt: "PumpedX",
        name: "PumpedX",
      },
      DonnyKing: {
        redirectUrl: "/casino/aggapturbogames-donny-king",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/DonnyKing.webp",
        alt: "Donny King",
        name: "Donny King",
      },
      CrystalPoker: {
        redirectUrl: "/casino/aggapturbogames-crystal-poker",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/CrystalPoker.webp",
        alt: "Crystal Poker",
        name: "Crystal Poker",
      },
      MultiplayerMines: {
        redirectUrl: "/casino/aggapturbogames-multiplayer-mines",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/MultiplayerMines.webp",
        alt: "Multiplayer Mines",
        name: "Multiplayer Mines",
      },
      BookOfMines: {
        redirectUrl: "/casino/aggapturbogames-book-of-mines",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/BookOfMines.webp",
        alt: "Book of Mines",
        name: "Book of Mines",
      },
      JewelClicker: {
        redirectUrl: "/casino/aggapturbogames-jewel-clicker",
        code: "",
        casino: "Slots",
        providerName: "TurboGames",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/turbo/JewelClicker.webp",
        alt: "Jewel Clicker",
        name: "Jewel Clicker",
      },
    },
    name: "Turbo Games",
    key: "turbo",
  },

  mac88: {
    slide1: {
      DragonTiger: {
        redirectUrl: "/casino/aggapmac88gaming-dragon-tiger",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/dragon-tiger.webp",
        alt: "Dragon Tiger",
        name: "Dragon Tiger",
      },
      DragonTiger2: {
        redirectUrl: "/casino/aggapmac88gaming-dragon-tiger-2",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/dragon-tiger-2.webp",
        alt: "Dragon Tiger 2",
        name: "Dragon Tiger 2",
      },
      DragonTigerLion: {
        redirectUrl: "/casino/aggapmac88gaming-dtl",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/dtl.webp",
        alt: "Dragon Tiger Lion",
        name: "Dragon Tiger Lion",
      },
      Day1DragonTiger: {
        redirectUrl: "/casino/aggapmac88gaming-1-day-dragon-tiger",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/1-day-dragon-tiger.webp",
        alt: "1 Day Dragon Tiger",
        name: "1 Day Dragon Tiger",
      },
      Baccarat29: {
        redirectUrl: "/casino/aggapmac88gaming-29-baccarat",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/29-baccarat.webp",
        alt: "29 Baccarat",
        name: "29 Baccarat",
      },
      BaccaratOneDay: {
        redirectUrl: "/casino/aggapmac88gaming-baccarat-one-day",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/baccarat-one-day.webp",
        alt: "Baccarat One Day",
        name: "Baccarat One Day",
      },
      SicBo: {
        redirectUrl: "/casino/aggapmac88gaming-sic-bo",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/sic-bo.webp",
        alt: "Sic Bo",
        name: "Sic Bo",
      },
      Roulette: {
        redirectUrl: "/casino/aggapmac88gaming-roulette",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/roulette.webp",
        alt: "Roulette",
        name: "Roulette",
      },
      Poker1Day: {
        redirectUrl: "/casino/aggapmac88gaming-poker-1-day",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/poker-1-day.webp",
        alt: "Poker 1-Day",
        name: "Poker 1-Day",
      },
      Poker2020: {
        redirectUrl: "/casino/aggapmac88gaming-poker-20-20",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/poker-20-20.webp",
        alt: "Poker 20-20",
        name: "Poker 20-20",
      },
      Player6Poker: {
        redirectUrl: "/casino/aggapmac88gaming-6-player-poker",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/6-player-poker.webp",
        alt: "6 Player Poker",
        name: "6 Player Poker",
      },
      MuflisTeenpatti: {
        redirectUrl: "/casino/aggapmac88gaming-muflis-teenpatti",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/muflis-teenpatti.webp",
        alt: "Muflis Teenpatti",
        name: "Muflis Teenpatti",
      },
      TwoCardTeenpatti: {
        redirectUrl: "/casino/aggapmac88gaming-two-card-teenpatti",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/2-card-teenpatti.webp",
        alt: "Two Card Teenpatti",
        name: "Two Card Teenpatti",
      },
      OpenTeenpatti: {
        redirectUrl: "/casino/aggapmac88gaming-open-teen-patti",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/open-teen-patti.webp",
        alt: "Open Teen patti",
        name: "Open Teen patti",
      },
      TeenpattiOneDay: {
        redirectUrl: "/casino/aggapmac88gaming-teenpatti-one-day",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/teenpatti-one-day.webp",
        alt: "Teenpatti One Day",
        name: "Teenpatti One Day",
      },
      TestTeenpatti: {
        redirectUrl: "/casino/aggapmac88gaming-test-teenpatti",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/test-teenpatti.webp",
        alt: "Test Teenpatti",
        name: "Test Teenpatti",
      },
      Teenpatti2020: {
        redirectUrl: "/casino/aggapmac88gaming-20-20-teenpatti",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/20-20-teenpatti.webp",
        alt: "20-20 Teenpatti",
        name: "20-20 Teenpatti",
      },
      Teenpatti20202: {
        redirectUrl: "/casino/aggapmac88gaming-20-20-teenpatti-2",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/20-20-teenpatti-2.webp",
        alt: "20 20 Teenpatti 2",
        name: "20 20 Teenpatti 2",
      },
      AK47Teenpatti: {
        redirectUrl: "/casino/aggapmac88gaming-ak47-teenpatti",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/ak47-teenpatti.webp",
        alt: "AK47 Teenpatti",
        name: "AK47 Teenpatti",
      },
      InstantTeenPatti: {
        redirectUrl: "/casino/aggapmac88gaming-instant-teen-patti",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/instant-teen-patti.webp",
        alt: "Instant Teen Patti",
        name: "Instant Teen Patti",
      },
      Highlow: {
        redirectUrl: "/casino/aggapmac88gaming-high-low",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/high-low.webp",
        alt: "High low",
        name: "High low",
      },
      HiLo: {
        redirectUrl: "/casino/aggapmac88gamingvirtual-hi-lo",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/hi-lo.webp",
        alt: "Hi Lo",
        name: "Hi Lo",
      },
      Lottery: {
        redirectUrl: "/casino/aggapmac88gaming-lottery",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/Lottery-Mac88.webp",
        alt: "Lottery",
        name: "Lottery",
      },
      BollywoodCasinoB: {
        redirectUrl: "/casino/aggapmac88gaming-bollywood-casino-b",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/bollywood-casino-b.webp",
        alt: "Bollywood Casino B",
        name: "Bollywood Casino B",
      },
      CasinoWar: {
        redirectUrl: "/casino/aggapmac88gaming-casino-war",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/casino-war.webp",
        alt: "Casino War",
        name: "Casino War",
      },
      CenterCard: {
        redirectUrl: "/casino/aggapmac88gaming-center-card",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/center-card.webp",
        alt: "Center card",
        name: "Center card",
      },
      Instantworli: {
        redirectUrl: "/casino/aggapmac88gaming-instant-worli",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/instant-worli.webp",
        alt: "Instant worli",
        name: "Instant worli",
      },
      NoteNumber: {
        redirectUrl: "/casino/aggapmac88gaming-note-number",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/note-number.webp",
        alt: "Note Number",
        name: "Note Number",
      },
      OneCard2020: {
        redirectUrl: "/casino/aggapmac88gaming-one-card-20-20",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/one-card-20-20.webp",
        alt: "One Card 20 20",
        name: "One Card 20 20",
      },
      OneCardOneDay: {
        redirectUrl: "/casino/aggapmac88gaming-one-card-one-day",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/one-card-one-day.webp",
        alt: "One Card One Day",
        name: "One Card One Day",
      },
      QueenRace: {
        redirectUrl: "/casino/aggapmac88gaming-queen-race",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/queen-race.webp",
        alt: "Queen Race",
        name: "Queen Race",
      },
      Race20: {
        redirectUrl: "/casino/aggapmac88gaming-race-20",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/race-20.webp",
        alt: "Race 20",
        name: "Race 20",
      },
      Raceto17: {
        redirectUrl: "/casino/aggapmac88gaming-race-to-17",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/race-to-17.webp",
        alt: "Race to 17",
        name: "Race to 17",
      },
      Raceto2nd: {
        redirectUrl: "/casino/aggapmac88gaming-race-to-2nd",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/race-to-2nd.webp",
        alt: "Race to 2nd",
        name: "Race to 2nd",
      },
      SideBetcity: {
        redirectUrl: "/casino/aggapmac88gaming-side-bet-city",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/side-bet-city.webp",
        alt: "Side Bet city",
        name: "Side Bet city",
      },
      CenterCardOneDay: {
        redirectUrl: "/casino/aggapmac88gaming-center-card-one-day",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/center-card-one-day.webp",
        alt: "Center Card One Day",
        name: "Center Card One Day",
      },
      Trio: {
        redirectUrl: "/casino/aggapmac88gaming-trio",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/trio.webp",
        alt: "Trio",
        name: "Trio",
      },
      WorliMatka: {
        redirectUrl: "/casino/aggapmac88gaming-worli-matka",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/worli-matka.webp",
        alt: "Worli Matka",
        name: "Worli Matka",
      },
      Cards3Judgement: {
        redirectUrl: "/casino/aggapmac88gaming-3-cards-judgement",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/3-cards-judgement.webp",
        alt: "3 Cards Judgement",
        name: "3 Cards Judgement",
      },
      AmarAkbarAnthony: {
        redirectUrl: "/casino/aggapmac88gaming-amar-akbar-anthony",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/amar-akbar-anthony.webp",
        alt: "Amar Akbar Anthony",
        name: "Amar Akbar Anthony",
      },
      Lucky7: {
        redirectUrl: "/casino/aggapmac88gaming-lucky7",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/lucky7.webp",
        alt: "Lucky 7",
        name: "Lucky 7",
      },
      Lucky5: {
        redirectUrl: "/casino/aggapmac88gaming-lucky-5",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/lucky-5.webp",
        alt: "Lucky 5",
        name: "Lucky 5",
      },
      AndarBahar: {
        redirectUrl: "/casino/aggapmac88gaming-andar-bahar",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/andar-bahar.webp",
        alt: "Andar Bahar",
        name: "Andar Bahar",
      },
      AndarBahar50: {
        redirectUrl: "/casino/aggapmac88gaming-andar-bahar-50",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/andar-bahar-50.webp",
        alt: "Andar Bahar 50",
        name: "Andar Bahar 50",
      },
      Cards32: {
        redirectUrl: "/casino/aggapmac88gaming-32-cards",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/32-cards.webp",
        alt: "32 Cards",
        name: "32 Cards",
      },
      DreamWheel: {
        redirectUrl: "/casino/aggapmac88gaming-dream-wheel",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/dream-wheel.webp",
        alt: "Dream Wheel",
        name: "Dream Wheel",
      },
      FootballStudIo: {
        redirectUrl: "/casino/aggapmac88gaming-football-studio",
        code: "",
        casino: "Mac88",
        providerName: "ALT_GAMING_GAP",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "/images/slots/mac88/football-studio.webp",
        alt: "Football StudIo",
        name: "Football StudIo",
      },
    },
    name: "Mac88",
    key: "mac88",
  },
  pragmaticplay: {
    slide1: {
      ...PragmaticPlayGames,
    },
    name: "Pragmatic Play",
    key: "pragmaticplay",
  },

  PGSoft: {
    slide1: {
      CashMania: {
        redirectUrl: "/casino/aggappg-cash-mania-u1195",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/CashMania.webp",
        alt: "Cash Mania",
        name: "Cash Mania",
      },
      BaccaratDeluxe: {
        redirectUrl: "/casino/aggappg-baccarat-deluxe",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/BaccaratDeluxe.webp",
        alt: "Baccarat Deluxe",
        name: "Baccarat Deluxe",
      },
      FortuneSnake: {
        redirectUrl: "/casino/aggappg-fortune-snake",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/FortuneSnake.webp",
        alt: "Fortune Snake",
        name: "Fortune Snake",
      },
      GeishasRevenge: {
        redirectUrl: "/casino/aggappg-geishas-revenge",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/GeishasRevenge.webp",
        alt: "Geisha's Revenge",
        name: "Geisha's Revenge",
      },
      ChocolateDeluxe: {
        redirectUrl: "/casino/aggappg-chocolate-deluxe",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/ChocolateDeluxe.webp",
        alt: "Chocolate Deluxe",
        name: "Chocolate Deluxe",
      },
      RioFantasia: {
        redirectUrl: "/casino/aggappg-rio-fantasia",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/RioFantasia.webp",
        alt: "Rio Fantasia",
        name: "Rio Fantasia",
      },
      MuseumMystery: {
        redirectUrl: "/casino/aggappg-museum-mystery",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/MuseumMystery.webp",
        alt: "Museum Mystery",
        name: "Museum Mystery",
      },
      OishiDelights: {
        redirectUrl: "/casino/aggappg-oishi-delights",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/OishiDelights.webp",
        alt: "Oishi Delights",
        name: "Oishi Delights",
      },
      ThreeCrazyPiggies: {
        redirectUrl: "/casino/aggappg-three-crazy-piggies",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/ThreeCrazyPiggies.webp",
        alt: "Three Crazy Piggies",
        name: "Three Crazy Piggies",
      },
      WingsofIguazu: {
        redirectUrl: "/casino/aggappg-wings-of-iguazu",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/WingsofIguazu.webp",
        alt: "Wings of Iguazu",
        name: "Wings of Iguazu",
      },
      YakuzaHonor: {
        redirectUrl: "/casino/aggappg-yakuza-honor",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/YakuzaHonor.webp",
        alt: "Yakuza Honor",
        name: "Yakuza Honor",
      },
      SharkBounty: {
        redirectUrl: "/casino/aggappg-shark-bounty",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/SharkBounty.webp",
        alt: "Shark Bounty",
        name: "Shark Bounty",
      },
      FutebolFever: {
        redirectUrl: "/casino/aggappg-futebol-fever",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/FutebolFever.webp",
        alt: "Futebol Fever",
        name: "Futebol Fever",
      },
      ChickyRun: {
        redirectUrl: "/casino/aggappg-chicky-run",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/ChickyRun.webp",
        alt: "Chicky Run",
        name: "Chicky Run",
      },
      ZombieOutbreak: {
        redirectUrl: "/casino/aggappg-zombie-outbreak",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/ZombieOutbreak.webp",
        alt: "Zombie Outbreak",
        name: "Zombie Outbreak",
      },
      AnubisWrath: {
        redirectUrl: "/casino/aggappg-anubis-wrath",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/AnubisWrath.webp",
        alt: "Anubis Wrath",
        name: "Anubis Wrath",
      },
      MysticPotion: {
        redirectUrl: "/casino/aggappg-mystic-potion",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/MysticPotion.webp",
        alt: "Mystic Potion",
        name: "Mystic Potion",
      },
      PinataWins: {
        redirectUrl: "/casino/aggappg-pinata-wins",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/PinataWins.webp",
        alt: "Pinata Wins",
        name: "Pinata Wins",
      },
      WildApe3258: {
        redirectUrl: "/casino/aggappg-wild-ape-3258",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/WildApe3258.webp",
        alt: "Wild Ape #3258",
        name: "Wild Ape #3258",
      },
      GemstonesGold: {
        redirectUrl: "/casino/aggappg-gemstones-gold",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/GemstonesGold.webp",
        alt: "Gemstones Gold",
        name: "Gemstones Gold",
      },
      FortuneDragon: {
        redirectUrl: "/casino/aggappg-fortune-dragon",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/FortuneDragon.webp",
        alt: "Fortune Dragon",
        name: "Fortune Dragon",
      },
      DragonHatch2: {
        redirectUrl: "/casino/aggappg-dragon-hatch-2",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/DragonHatch2.webp",
        alt: "Dragon Hatch 2",
        name: "Dragon Hatch 2",
      },
      WerewolfsHunt: {
        redirectUrl: "/casino/aggappg-werewolfs-hunt",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/WerewolfsHunt.webp",
        alt: "Werewolf's Hunt",
        name: "Werewolf's Hunt",
      },
      TsarTreasures: {
        redirectUrl: "/casino/aggappg-tsar-treasures",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/TsarTreasures.webp",
        alt: "Tsar Treasures",
        name: "Tsar Treasures",
      },
      MafiaMayhem: {
        redirectUrl: "/casino/aggappg-mafia-mayhem",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/MafiaMayhem.webp",
        alt: "Mafia Mayhem",
        name: "Mafia Mayhem",
      },
      ForgeofWealth: {
        redirectUrl: "/casino/aggappg-forge-of-wealth",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/ForgeofWealth.webp",
        alt: "Forge of Wealth",
        name: "Forge of Wealth",
      },
      WildHeistCashout: {
        redirectUrl: "/casino/aggappg-wild-heist-cashout",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/WildHeistCashout.webp",
        alt: "Wild Heist Cashout",
        name: "Wild Heist Cashout",
      },
      UltimateStriker: {
        redirectUrl: "/casino/aggappg-ultimate-striker",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/UltimateStriker.webp",
        alt: "Ultimate Striker",
        name: "Ultimate Striker",
      },
      NinjaRaccoonFrenzy: {
        redirectUrl: "/casino/aggappg-ninja-raccoon-frenzy",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/NinjaRaccoonFrenzy.webp",
        alt: "Ninja Raccoon Frenzy",
        name: "Ninja Raccoon Frenzy",
      },
      GladiatorsGlory: {
        redirectUrl: "/casino/aggappg-gladiators-glory",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/GladiatorsGlory.webp",
        alt: "Gladiator's Glory",
        name: "Gladiator's Glory",
      },
      SafariWilds: {
        redirectUrl: "/casino/aggappg-safari-wilds",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/SafariWilds.webp",
        alt: "Safari Wilds",
        name: "Safari Wilds",
      },
      CruiseRoyale: {
        redirectUrl: "/casino/aggappg-cruise-royale",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/CruiseRoyale.webp",
        alt: "Cruise Royale",
        name: "Cruise Royale",
      },
      FruityCandy: {
        redirectUrl: "/casino/aggappg-fruity-candy",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/FruityCandy.webp",
        alt: "Fruity Candy",
        name: "Fruity Candy",
      },
      LuckyCloverLady: {
        redirectUrl: "/casino/aggappg-lucky-clover-lady",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/LuckyCloverLady.webp",
        alt: "Lucky Clover Lady",
        name: "Lucky Clover Lady",
      },
      SuperGolfDrive: {
        redirectUrl: "/casino/aggappg-super-golf-drive",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/SuperGolfDrive.webp",
        alt: "Super Golf Drive",
        name: "Super Golf Drive",
      },
      MysticalSpirits: {
        redirectUrl: "/casino/aggappg-mystical-spirits",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/MysticalSpirits.webp",
        alt: "Mystical Spirits",
        name: "Mystical Spirits",
      },
      SongkranSplash: {
        redirectUrl: "/casino/aggappg-songkran-splash",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/SongkranSplash.webp",
        alt: "Songkran Splash",
        name: "Songkran Splash",
      },
      BakeryBonanza: {
        redirectUrl: "/casino/aggappg-bakery-bonanza",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/BakeryBonanza.webp",
        alt: "Bakery Bonanza",
        name: "Bakery Bonanza",
      },
      HawaiianTiki: {
        redirectUrl: "/casino/aggappg-hawaiian-tiki",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/HawaiianTiki.webp",
        alt: "Hawaiian Tiki",
        name: "Hawaiian Tiki",
      },
      RavePartyFever: {
        redirectUrl: "/casino/aggappg-rave-party-fever",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/RavePartyFever.webp",
        alt: "Rave Party Fever",
        name: "Rave Party Fever",
      },
      FortuneRabbit: {
        redirectUrl: "/casino/aggappg-fortune-rabbit",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/FortuneRabbit.webp",
        alt: "Fortune Rabbit",
        name: "Fortune Rabbit",
      },
      MidasFortune: {
        redirectUrl: "/casino/aggappg-midas-fortune",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/MidasFortune.webp",
        alt: "Midas Fortune",
        name: "Midas Fortune",
      },
      AsgardianRising: {
        redirectUrl: "/casino/aggappg-asgardian-rising",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/AsgardianRising.webp",
        alt: "Asgardian Rising",
        name: "Asgardian Rising",
      },
      DinerDelights: {
        redirectUrl: "/casino/aggappg-diner-delights",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/DinerDelights.webp",
        alt: "Diner Delights",
        name: "Diner Delights",
      },
      AlchemyGold: {
        redirectUrl: "/casino/aggappg-alchemy-gold",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/AlchemyGold.webp",
        alt: "Alchemy Gold",
        name: "Alchemy Gold",
      },
      TotemWonders: {
        redirectUrl: "/casino/aggappg-totem-wonders",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/TotemWonders.webp",
        alt: "Totem Wonders",
        name: "Totem Wonders",
      },
      ProsperityFortuneTree: {
        redirectUrl: "/casino/aggappg-prosperity-fortune-tree",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/ProsperityFortuneTree.webp",
        alt: "Prosperity Fortune Tree",
        name: "Prosperity Fortune Tree",
      },
      WildBountyShowdown: {
        redirectUrl: "/casino/aggappg-wild-bounty-showdown",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/WildBountyShowdown.webp",
        alt: "Wild Bounty Showdown",
        name: "Wild Bounty Showdown",
      },
      WildCoaster: {
        redirectUrl: "/casino/aggappg-wild-coaster",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/WildCoaster.webp",
        alt: "Wild Coaster",
        name: "Wild Coaster",
      },
      LegendofPerseus: {
        redirectUrl: "/casino/aggappg-legend-of-perseus",
        code: "",
        casino: "Slot",
        provider: "ALT_GAMING_GAP",
        category: "pocketGamesSoft",
        homeUrl: "http://localhost:3000/Casino",
        imgUrl: "./images/slots/pg-soft/LegendofPerseus.webp",
        alt: "Legend of Perseus",
        name: "Legend of Perseus",
      },
    },
    name: "Pocket Games Soft",
    key: "PGSoftGames",
  },
};
